import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'dashboard', affix: true }
    }
    ]
  },
  {
    hidden: true,
    path: '',
    component: Layout,
    redirect: '/userCenter',
    meta: { title: '个人中心', icon: 'user' },
    children: [{
      path: 'userCenter',
      name: 'userCenter',
      component: () => import('@/views/userCenter/index'),
      meta: { title: '个人中心', icon: 'user' }
    }
    ]
  },
  // 标签页“刷新当前页”中转路由
  {
    hidden: true,
    path: '/redirect',
    component: Layout,
    children: [{
      path: ':path*',
      component: {
        beforeRouteEnter(to, from, next) {
          next(vm => {
            vm.$router.replace('/' + to.params.path)
          })
        },
        render(h) {
          return h()
        }
      }
    }]
  },
]

export const asyncRouterMap = [{
  path: '/merchantManage',
  component: Layout,
  redirect: '/merchantManage/mlist',
  name: 'merchantManage',
  meta: { title: '商家管理', icon: 'order' },
  children: [{
    path: 'manageList',
    name: 'manageList',
    component: () => import('@/views/merchantManage/manageList'),
    meta: { title: '商家列表', icon: 'order' }
  }, {
    path: 'merchantMenu',
    name: 'merchantMenu',
    component: () => import('@/views/merchantManage/merchantMenu'),
    meta: { title: '商家菜单', icon: 'order' }
  }]
}, {
  path: '/user',
  component: Layout,
  redirect: '/user/list',
  name: 'user',
  meta: { title: '会员管理', icon: 'user' },
  children: [{
    path: 'list',
    name: 'list',
    component: () => import('@/views/user/list/index'),
    meta: { title: '会员列表', icon: 'product-list' }
  }, {
    path: 'carrierList',
    name: 'carrierList',
    component: () => import('@/views/user/list/carrierList'),
    meta: { title: '带货者列表', icon: 'product-list' }
  }, {
    path: 'openSet',
    name: 'openSet',
    component: () => import('@/views/user/openSet/index'),
    meta: { title: '开通配置', icon: 'order-setting' }
  }, {
    path: 'vipSet',
    name: 'vipSet',
    component: () => import('@/views/user/vipSet'),
    meta: { title: '会员配置', icon: 'order-setting' }
  },
  {
    path: 'performance',
    name: 'performance',
    component: () => import('@/views/user/performance/index'),
    meta: { title: '会员业绩', icon: 'order-setting' }
  },
  {
    path: 'payFeeList',
    name: 'payFeeList',
    component: () => import('@/views/user/payFeeList/index'),
    meta: { title: '缴费列表', icon: 'order-setting' }
  }, {
    path: 'withdrawalApproval',
    name: 'withdrawalApproval',
    component: () => import('@/views/user/withdrawalApproval/index'),
    meta: { title: '提现审核', icon: 'order-setting' }
  }, {
    path: 'userStock',
    name: 'userStock',
    component: () => import('@/views/user/userStock'),
    meta: { title: '用户库存', icon: 'product-cate' }
  }]
},
{
  path: '/pms',
  component: Layout,
  redirect: '/pms/product',
  name: 'pms',
  meta: { title: '商品', icon: 'product' },
  children: [{
    path: 'product',
    name: 'product',
    component: () => import('@/views/pms/product/index'),
    meta: { title: '商品列表', icon: 'product-list' }
  },
  {
    path: 'goodItems',
    name: 'goodItems',
    component: () => import('@/views/pms/product/goodItems'),
    meta: { title: '商品列表', icon: 'product-list' }
  },
  {
    path: 'addProduct',
    name: 'addProduct',
    component: () => import('@/views/pms/product/add'),
    meta: { title: '添加商品', icon: 'product-add' }
  },
  {
    path: 'antiCount',
    name: 'antiCount',
    component: () => import('@/views/pms/antiCount/antiCount'),
    meta: { title: '防伪码', icon: 'product-list' }
  }, {
    path: 'antiCounterfeiting',
    name: 'antiCounterfeiting',
    component: () => import('@/views/pms/antiCounterfeiting/antiCounterfeiting'),
    meta: { title: '防伪追溯', icon: 'product-list' }
  },
  {
    path: 'updateProduct',
    name: 'updateProduct',
    component: () => import('@/views/pms/product/update'),
    meta: { title: '修改商品', icon: 'product-add' },
    hidden: true
  },
  {
    path: 'productCate',
    name: 'productCate',
    component: () => import('@/views/pms/productCate/index'),
    meta: { title: '商品分类', icon: 'product-cate' }
  },
  {
    path: 'addProductCate',
    name: 'addProductCate',
    component: () => import('@/views/pms/productCate/add'),
    meta: { title: '添加商品分类' },
    hidden: true
  },
  {
    path: 'updateProductCate',
    name: 'updateProductCate',
    component: () => import('@/views/pms/productCate/update'),
    meta: { title: '修改商品分类' },
    hidden: true
  },
  {
    path: 'productAttr',
    name: 'productAttr',
    component: () => import('@/views/pms/productAttr/index'),
    meta: { title: '商品类型', icon: 'product-attr' }
  },
  {
    path: 'productAttrList',
    name: 'productAttrList',
    component: () => import('@/views/pms/productAttr/productAttrList'),
    meta: { title: '商品属性列表' },
    hidden: true
  },
  {
    path: 'addProductAttr',
    name: 'addProductAttr',
    component: () => import('@/views/pms/productAttr/addProductAttr'),
    meta: { title: '添加商品属性' },
    hidden: true
  },
  {
    path: 'updateProductAttr',
    name: 'updateProductAttr',
    component: () => import('@/views/pms/productAttr/updateProductAttr'),
    meta: { title: '修改商品属性' },
    hidden: true
  },
  {
    path: 'brand',
    name: 'brand',
    component: () => import('@/views/pms/brand/index'),
    meta: { title: '品牌管理', icon: 'product-brand' }
  },
  {
    path: 'addBrand',
    name: 'addBrand',
    component: () => import('@/views/pms/brand/add'),
    meta: { title: '添加品牌' },
    hidden: true
  },
  {
    path: 'updateBrand',
    name: 'updateBrand',
    component: () => import('@/views/pms/brand/update'),
    meta: { title: '编辑品牌' },
    hidden: true
  }
  ]
},
{
  path: '/oms',
  component: Layout,
  redirect: '/oms/order',
  name: 'oms',
  meta: { title: '订单', icon: 'order' },
  children: [
    {
      path: 'order',
      name: 'order',
      component: () => import('@/views/oms/order/index'),
      meta: { title: '订单列表', icon: 'product-list' }
    }, {
      path: 'commissionOrders',
      name: 'commissionOrders',
      component: () => import('@/views/oms/order/commissionOrders'),
      meta: { title: '佣金单列表', icon: 'product-list' }
    },
    {
      path: 'recharge',
      name: 'recharge',
      component: () => import('@/views/oms/order/recharge'),
      meta: { title: '运费充值', icon: 'product-list' }
    },
    {
      path: 'walletRecharge',
      name: 'walletRecharge',
      component: () => import('@/views/oms/order/walletRecharge'),
      meta: { title: '钱包充值', icon: 'product-list' }
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/oms/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'repairOrder',
      name: 'repairOrder',
      component: () => import('@/views/oms/order/repairOrder'),
      meta: { title: '补货订单列表', icon: 'product-list' }
    },
    {
      path: 'repairOrderDetail',
      name: 'repairOrderDetail',
      component: () => import('@/views/oms/order/repairOrderDetail'),
      meta: { title: '补货订单详情' },
      hidden: true
    },
    {
      path: 'deliverOrderList',
      name: 'deliverOrderList',
      component: () => import('@/views/oms/order/deliverOrderList'),
      meta: { title: '发货列表' },
      hidden: true
    },
    {
      path: 'adressSeting',
      name: 'adressSeting',
      component: () => import('@/views/oms/order/adressSeting'),
      meta: { title: '收货地址' },
      hidden: true
    },
    {
      path: 'orderSetting',
      name: 'orderSetting',
      component: () => import('@/views/oms/order/setting'),
      meta: { title: '订单设置', icon: 'order-setting' }
    },
    {
      path: 'returnApply',
      name: 'returnApply',
      component: () => import('@/views/oms/apply/index'),
      meta: { title: '退货申请处理', icon: 'order-return' }
    },
    {
      path: 'returnReason',
      name: 'returnReason',
      component: () => import('@/views/oms/apply/reason'),
      meta: { title: '退货原因设置', icon: 'order-return-reason' }
    },
    {
      path: 'returnApplyDetail',
      name: 'returnApplyDetail',
      component: () => import('@/views/oms/apply/applyDetail'),
      meta: { title: '退货原因详情' },
      hidden: true
    }
  ]
},
{
  path: '/sms',
  component: Layout,
  redirect: '/sms/coupon',
  name: 'sms',
  meta: { title: '营销', icon: 'sms' },
  children: [
    {
      path: 'flash',
      name: 'flash',
      component: () => import('@/views/sms/flash/index'),
      meta: { title: '秒杀活动列表', icon: 'sms-flash' }
    }, {
      path: 'WeCom',
      name: 'WeCom',
      component: () => import('@/views/sms/WeCom/index'),
      meta: { title: '企业微信', icon: 'sms-flash' }
    }, {
      path: 'productVideo',
      name: 'productVideo',
      component: () => import('@/views/sms/productVideo/index'),
      meta: { title: '带货视频', icon: 'sms-flash' }
    },
    {
      path: 'flashSession',
      name: 'flashSession',
      component: () => import('@/views/sms/flash/sessionList'),
      meta: { title: '秒杀时间段列表' },
      hidden: true
    },
    {
      path: 'selectSession',
      name: 'selectSession',
      component: () => import('@/views/sms/flash/selectSessionList'),
      meta: { title: '秒杀时间段选择' },
      hidden: true
    },
    {
      path: 'flashProductRelation',
      name: 'flashProductRelation',
      component: () => import('@/views/sms/flash/productRelationList'),
      meta: { title: '秒杀商品列表' },
      hidden: true
    },
    {
      path: 'coupon',
      name: 'coupon',
      component: () => import('@/views/sms/coupon/index'),
      meta: { title: '优惠券列表', icon: 'sms-coupon' }
    },
    {
      path: 'addCoupon',
      name: 'addCoupon',
      component: () => import('@/views/sms/coupon/add'),
      meta: { title: '添加优惠券' },
      hidden: true
    },
    {
      path: 'updateCoupon',
      name: 'updateCoupon',
      component: () => import('@/views/sms/coupon/update'),
      meta: { title: '修改优惠券' },
      hidden: true
    },
    {
      path: 'couponHistory',
      name: 'couponHistory',
      component: () => import('@/views/sms/coupon/history'),
      meta: { title: '优惠券领取详情' },
      hidden: true
    },
    {
      path: 'brand',
      name: 'homeBrand',
      component: () => import('@/views/sms/brand/index'),
      meta: { title: '品牌推荐', icon: 'product-brand' }
    },
    {
      path: 'new',
      name: 'homeNew',
      component: () => import('@/views/sms/new/index'),
      meta: { title: '新品推荐', icon: 'sms-new' }
    },
    {
      path: 'hot',
      name: 'homeHot',
      component: () => import('@/views/sms/hot/index'),
      meta: { title: '人气推荐', icon: 'sms-hot' }
    },
    {
      path: 'subject',
      name: 'homeSubject',
      component: () => import('@/views/sms/subject/index'),
      meta: { title: '专题推荐', icon: 'sms-subject' }
    },
    {
      path: 'advertise',
      name: 'homeAdvertise',
      component: () => import('@/views/sms/advertise/index'),
      meta: { title: '广告列表', icon: 'sms-ad' }
    },
    // {
    //   path: 'competition',
    //   name: 'competition',
    //   component: () => import('@/views/sms/competition/index'),
    //   meta: { title: 'PK活动', icon: 'sms-ad' }
    // },
    {
      path: 'offlineEvent',
      name: 'offlineEvent',
      component: () => import('@/views/sms/offlineEvent/index'),
      meta: { title: '线下活动' ,icon: 'sms-ad'}
    },
    {
      path: 'addOfflineEvent',
      name: 'addOfflineEvent',
      component: () => import('@/views/sms/offlineEvent/add'),
      meta: { title: '添加活动' },
      hidden: true
    },
    {
      path: 'updateOfflineEvent',
      name: 'updateOfflineEvent',
      component: () => import('@/views/sms/offlineEvent/update'),
      meta: { title: '编辑活动' },
      hidden: true
    },
    {
      path: 'resultOfflineEvent',
      name: 'resultOfflineEvent',
      component: () => import('@/views/sms/offlineEvent/result'),
      meta: { title: '投票结果' },
      hidden: true
    },
    {
      path: 'copywriting',
      name: 'copywriting',
      component: () => import('@/views/sms/copywriting/index'),
      meta: { title: '文案配置', icon: 'sms-ad' }
    },

    {
      path: 'addCopywriting',
      name: 'addCopywriting',
      component: () => import('@/views/sms/copywriting/add'),
      meta: { title: '添加文案' },
      hidden: true
    },
    {
      path: 'updateCopywriting',
      name: 'updateCopywriting',
      component: () => import('@/views/sms/copywriting/update'),
      meta: { title: '编辑文案' },
      hidden: true
    },
    {
      path: 'addAdvertise',
      name: 'addHomeAdvertise',
      component: () => import('@/views/sms/advertise/add'),
      meta: { title: '添加广告' },
      hidden: true
    },
    {
      path: 'updateAdvertise',
      name: 'updateHomeAdvertise',
      component: () => import('@/views/sms/advertise/update'),
      meta: { title: '编辑广告' },
      hidden: true
    }
  ]
},
{
  path: '/ums',
  component: Layout,
  redirect: '/ums/admin',
  name: 'ums',
  meta: { title: '权限', icon: 'ums' },
  children: [
    {
      path: 'admin',
      name: 'admin',
      component: () => import('@/views/ums/admin/index'),
      meta: { title: '用户列表', icon: 'ums-admin' }
    },
    {
      path: 'role',
      name: 'role',
      component: () => import('@/views/ums/role/index'),
      meta: { title: '角色列表', icon: 'ums-role' }
    },
    {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/role/allocMenu'),
      meta: { title: '分配菜单' },
      hidden: true
    },
    {
      path: 'allocResource',
      name: 'allocResource',
      component: () => import('@/views/ums/role/allocResource'),
      meta: { title: '分配资源' },
      hidden: true
    },
    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/ums/menu/index'),
      meta: { title: '菜单列表', icon: 'ums-menu' }
    },
    {
      path: 'addMenu',
      name: 'addMenu',
      component: () => import('@/views/ums/menu/add'),
      meta: { title: '添加菜单' },
      hidden: true
    },
    {
      path: 'updateMenu',
      name: 'updateMenu',
      component: () => import('@/views/ums/menu/update'),
      meta: { title: '修改菜单' },
      hidden: true
    },
    {
      path: 'resource',
      name: 'resource',
      component: () => import('@/views/ums/resource/index'),
      meta: { title: '资源列表', icon: 'ums-resource' }
    },
    {
      path: 'resourceCategory',
      name: 'resourceCategory',
      component: () => import('@/views/ums/resource/categoryList'),
      meta: { title: '资源分类' },
      hidden: true
    },
    {
      path: 'systemNote',
      name: 'systemNote',
      component: () => import('@/views/ums/system/systemNote'),
      meta: { title: '系统日志' },
      hidden: true
    },
    {
      path: 'agreement',
      name: 'agreement',
      component: () => import('@/views/ums/agreement/index'),
      meta: { title: '协议列表' },
      hidden: true
    },
    {
      path: 'versionControl',
      name: 'versionControl',
      component: () => import('@/views/ums/versionControl/index'),
      meta: { title: '版本管理' },
      hidden: true
    },
    
    {
      path: 'problem',
      name: 'problem',
      component: () => import('@/views/ums/problem/index'),
      meta: { title: '常见问题', icon: 'ums-problem' }
    },
    {
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/ums/feedback/index'),
      meta: { title: '投诉反馈', icon: 'ums-problem' }
    },
    {
      path: 'addProblem',
      name: 'addProblem',
      component: () => import('@/views/ums/problem/add'),
      meta: { title: '添加问题' },
      hidden: true
    },
    {
      path: 'updateProblem',
      name: 'updateProblem',
      component: () => import('@/views/ums/problem/update'),
      meta: { title: '修改问题' },
      hidden: true
    }
  ]
},
{ path: '*', redirect: '/404', hidden: true }
]

// 路由预处理：
// 1. 隐藏页面（详情页、编辑表单等）默认不缓存，避免带不同参数打开时残留上一次的数据
// 2. 给懒加载组件注入与路由一致的 name，供 <keep-alive :include> 按路由 name 精确缓存
function prepareRouteTree(routes) {
  routes.forEach(route => {
    if (route.hidden === true && route.meta) {
      route.meta.noCache = true
    }
    if (route.name && typeof route.component === 'function' && !route.__nameInjected) {
      const originalLoader = route.component
      const routeName = route.name
      route.component = () => originalLoader().then(mod => {
        if (mod && mod.default) {
          mod.default.name = routeName
        }
        return mod
      })
      route.__nameInjected = true
    }
    if (route.children && route.children.length) {
      prepareRouteTree(route.children)
    }
  })
}
prepareRouteTree(constantRouterMap)
prepareRouteTree(asyncRouterMap)

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js